import { isRecord } from '@shared/utils/isRecord';

// A plain hex colour only: the value reaches inline styles and the header's colour pipeline (which
// parses hex), so keywords, functions and anything else are dropped.
const PLAIN_HEX = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i;

const colorOption = (options: unknown, key: 'namesColor' | 'navColor'): string | undefined => {
  const value = isRecord(options) ? options[key] : undefined;
  return typeof value === 'string' && PLAIN_HEX.test(value.trim()) ? value.trim() : undefined;
};

/**
 * The names colour a template gives a multi-photo Motion type (Showcase, Polaroid), from saved Motion
 * options, or `undefined` when it is absent or not a plain hex colour. It also colours the nav unless
 * `navColor` is set. Pure; never throws.
 */
export const motionNamesColor = (options: unknown): string | undefined => colorOption(options, 'namesColor');

/**
 * A separate nav colour, for a type whose names sit on photos while the nav sits on the plain page
 * (Polaroid). Same rules as `motionNamesColor`.
 */
export const motionNavColor = (options: unknown): string | undefined => colorOption(options, 'navColor');
